import React from "react";

import Switch from "./index";

const SwitchContainer = (props: any) => {
	return (
		<Switch
			label={props.label}
			enabled={props.input.value}
			{...props.input}
		/>
	);
};

export default SwitchContainer;
